import React from 'react'
import { Mutation } from 'react-apollo'

import { VERIFY_EMAIL_CHANGE } from '../graphql/mutations'
import GetPlatformImages from '../hocs/queries/GetPlatformImages'

import AppBranding from '../components/AppBranding'
import VerificationForm from '../components/VerificationForm'

class EmailVerification extends React.Component {
  render() {
    const [image] = this.props.platformImages.filter(i => i.location === 'verification')
    return (
      <div className='login'>
        <div className='loginBackground'>
          <img src={image.fullPath} alt={image.altText} />
          {image.caption && <div className='loginBackgroundCredit'>{image.caption}</div>}
        </div>
        <div className='loginFormBackground'>
          <div className='loginFormWrapper'>
            <AppBranding />
            <div className='loginForm'>
              <Mutation
                mutation={VERIFY_EMAIL_CHANGE}
                update={(cache, { data: { doEmailChangeVerification } }) => {
                  localStorage.setItem('authToken', doEmailChangeVerification.accessToken)

                  cache.writeData({
                    data: {
                      authStatus: {
                        __typename: 'authStatus',
                        status: 'loggedIn'
                      }
                    }
                  })

                  this.props.history.push('/account')
                }}
              >
                {(doEmailChangeVerification, { loading, error }) => (
                  <VerificationForm
                    onSubmit={state => {
                        doEmailChangeVerification({
                        variables: {
                          ...state,
                          token: this.props.match.params.token
                        }
                      }).catch(() => {
                        //
                      })
                    }}
                    loading={loading}
                    errors={error}
                  />
                )}
              </Mutation>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default GetPlatformImages(EmailVerification)
